<template>
  <div>
    <div class="text-right pb-1">
      <router-link class="text-xs uppercase mr-2" to="/personalize">Personalize</router-link>
      <button class="text-xs uppercase mr-2" @click="reparse">Reparse</button>
      <button class="text-xs uppercase" @click="resetFilters">Reset Filter</button>
    </div>
    <label class="block">
      <input @change="filter" v-model="searchString" type="search" class=" form-input block w-full border-0 shadow-md p-2" placeholder="Search">
    </label>
    <div class="block uppercase mt-1">
      <span class="text-xs uppercase">priority</span>
      <radio-buttons @selection="prioritySelected" :value="selectedPriority" :options="priorities"></radio-buttons>
    </div>
    <!-- disable for now since we can't make it work with insertShitAt (jumping shit) -->
    <!-- <label class="block uppercase">
      <span class="text-xs uppercase">order</span>
      <radio-buttons @selection="orderSelected" :value="selectedOrder" :options="orders"></radio-buttons>
    </label> -->
    <label class="block uppercase">
      <span class="text-xs uppercase">action</span>
      <checkbox-buttons @selection="actionsSelected" :value="selectedActions" :options="actions"></checkbox-buttons>
    </label>
    <label class="block" :class="{'pointer-events-none text-gray-500': !this.selectedActions.includes('schedule')}">
      <span class="text-xs uppercase">Schedule</span>
      <select class="form-select mt-1 block w-full" v-model="selectedSchedule">
        <option v-for="schedule in schedules" :key="schedule.label">{{ schedule }}</option>
      </select>
    </label>
    <label class="block" v-if="projects.length">
      <span class="text-xs uppercase">#projects</span>
      <checkbox-buttons @selection="projectsSelected" :value="selectedProjects" :options="projects"></checkbox-buttons>
    </label>
    <label class="block" v-if="contexts.length">
      <span class="text-xs uppercase">@contexts</span>
      <checkbox-buttons @selection="contextsSelected" :value="selectedContexts" :options="contexts"></checkbox-buttons>
    </label>
    <label class="block" v-if="mentions.length">
      <span class="text-xs uppercase">+mentions</span>
      <checkbox-buttons @selection="mentionsSelected" :value="selectedMentions" :options="mentions"></checkbox-buttons>
    </label>
    <label class="block uppercase">
      <span class="text-xs uppercase">Done shits</span>
      <radio-buttons @selection="doneTypeSelected" :value="selectedDoneType" :options="doneTypes"></radio-buttons>
    </label>
  </div>
</template>

<script>
import shit from '../mixins/shit'
import CheckboxButtons from './CheckboxButtons'
import RadioButtons from './RadioButtons'
import { mapGetters, mapMutations } from 'vuex'
import { actionTypes, actionFilters } from '../constants/shit-action-types'
import { priorityTypes } from '../constants/shit-priority-types'
import { isShitDoneToday, isShitDoneThisWeek, parseShitMetas } from '../constants/shit-functions'
import { scheduleTypes, scheduleFilters } from '../constants/shit-schedule-types'
import { doneTypes, doneFilters } from '../constants/shit-done-types'

export default {
  mixins: [shit],
  data () {
    return {
      // @todo remove any
      actions: ['any', 'none'].concat(Object.values(actionTypes)),
      priorities: Object.values(priorityTypes),
      doneTypes: Object.values(doneTypes),
      // orders: ['priority', 'new shit first', 'new shit last'],
      schedules: Object.values(scheduleTypes)
    }
  },
  computed: {
    ...mapGetters(['contexts', 'projects', 'mentions', 'mits', 'bigRocks']),
    searchString: {
      get () {
        return this.$store.state.filters.searchString
      },
      set (value) {
        this.$store.commit('filters/setSearchString', value)
      }
    },
    selectedSchedule: {
      get () {
        return this.$store.state.filters.selectedSchedule
      },
      set (value) {
        this.$store.commit('filters/setSelectedSchedule', value)
      }
    },
    selectedContexts: {
      get () {
        return this.$store.state.filters.selectedContexts
      },
      set (value) {
        this.$store.commit('filters/setSelectedContexts', value)
      }
    },
    selectedProjects: {
      get () {
        return this.$store.state.filters.selectedProjects
      },
      set (value) {
        this.$store.commit('filters/setSelectedProjects', value)
      }
    },
    selectedMentions: {
      get () {
        return this.$store.state.filters.selectedMentions
      },
      set (value) {
        this.$store.commit('filters/setSelectedMentions', value)
      }
    },
    selectedActions: {
      get () {
        return this.$store.state.filters.selectedActions
      },
      set (value) {
        this.$store.commit('filters/setSelectedActions', value)
      }
    },
    selectedDoneType: {
      get () {
        return this.$store.state.filters.selectedDoneType
      },
      set (value) {
        this.$store.commit('filters/setSelectedDoneType', value)
      }
    },
    // selectedOrder: {
    //   get () {
    //     return this.$store.state.filters.selectedOrder
    //   },
    //   set (value) {
    //     this.$store.commit('filters/setSelectedOrder', value)
    //   }
    // },
    selectedPriority: {
      get () {
        return this.$store.state.filters.selectedPriority
      },
      set (value) {
        this.$store.commit('filters/setSelectedPriority', value)
      }
    }
  },
  components: {
    CheckboxButtons,
    RadioButtons
  },
  mounted () {
    this.filter()
    // this.sort()
  },
  methods: {
    ...mapMutations('filters', ['reset']),
    reparse () {
      // @todo UI
      this.$store.state.shits.forEach(shit => {
        const updates = parseShitMetas(shit.description)
        updates.description = shit.description
        updates.uuid = shit.uuid
        this.$store.dispatch('syncShit', updates)
      })
      window.location.reload()
    },
    resetFilters () {
      this.reset()
      window.location.reload()
    },
    contextsSelected (selectedContexts) {
      this.selectedContexts = selectedContexts
      this.filter()
    },
    projectsSelected (selectedProjects) {
      this.selectedProjects = selectedProjects
      this.filter()
    },
    mentionsSelected (selectedMentions) {
      this.selectedMentions = selectedMentions
      this.filter()
    },
    actionsSelected (action) {
      this.selectedActions = action
      this.filter()
    },
    prioritySelected (priority) {
      this.selectedPriority = priority
      this.filter()
    },
    doneTypeSelected (option) {
      this.selectedDoneType = option
      this.filter()
    },
    filter () {
      const callback = shit => {
        let matches = true

        if (this.searchString) {
          matches = matches && shit.description && shit.description.toLowerCase().includes(this.searchString.toLowerCase())
        }

        if (this.selectedProjects.length) {
          matches = matches && this.selectedProjects.filter(sp => shit.projects && shit.projects.includes(sp)).length
        }

        if (this.selectedContexts.length) {
          matches = matches && this.selectedContexts.filter(sp => shit.contexts && shit.contexts.includes(sp)).length
        }

        if (this.selectedMentions.length) {
          matches = matches && this.selectedMentions.filter(sp => shit.mentions && shit.mentions.includes(sp)).length
        }

        // @todo move to shit-action-types
        if (this.selectedActions) {
          actionFilters.any = shit => true
          actionFilters.none = shit => !shit.action
          const actionMatches = this.selectedActions.reduce(
            (accumulator, currentValue) => {
              return accumulator || actionFilters[currentValue](shit)
            },
            false
          )
          matches = matches && actionMatches
        }

        if (this.selectedPriority) {
          const priorityFilters = {
            [priorityTypes.SHIT_PRIORITY_ANY]: () => {
              return true
            },
            [priorityTypes.SHIT_PRIORITY_MIT]: (shit) => {
              return this.isShitMit(shit) && (!shit.completedAt || isShitDoneToday(shit))
            },
            [priorityTypes.SHIT_PRIORITY_BIGROCK]: (shit) => {
              return this.isShitBigRock(shit) && (!shit.completedAt || isShitDoneThisWeek(shit))
            }
          }

          matches = matches && priorityFilters[this.selectedPriority](shit)
        }

        if (this.selectedSchedule) {
          matches = matches && scheduleFilters[this.selectedSchedule](shit)
        }

        if (this.selectedDoneType) {
          matches = matches && doneFilters[this.selectedDoneType](shit)
        }

        return matches
      }

      this.$emit('filter', callback)
    }
    // orderSelected (selectedOrder) {
    //   this.selectedOrder = selectedOrder
    //   this.sort()
    // },
    /*
    sort () {
      // return < 0: a, b
      // return = 0: _as is_
      // return > 0: b, a
      // orders: ['priority', 'new shit first', 'new shit last']
      const compareFn = (one, two) => {
        console.warn(this.selectedOrder, one.description, two.description)
        if (this.selectedOrder === 'priority') {
          // mit, br, p

          if (this.isShitMit(one)) {
            return -1
          } else if (this.isShitMit(two)) {
            return 1
          }

          if (this.isShitBigRock(one)) {
            return -1
          } else if (this.isShitBigRock(two)) {
            return 1
          }

          return 0
        } else if (this.selectedOrder === 'new shit first') {
          return new Date(two.createdAt) - new Date(one.createdAt)
        } else if (this.selectedOrder === 'new shit last') {
          return new Date(one.createdAt) - new Date(two.createdAt)
        }

        return 0
      }

      this.$emit('sort', compareFn)
    }
    */
  }
}
</script>
